export default /* css */ `
@keyframes navigation-open {
  0% {
    width: 0;
    height: calc(var(--stripe-purple-width-light) * 2);
  }

  45% {
    width: 100%;
    height: calc(var(--stripe-purple-width-light) * 2);
  }

  100% {
    width: 100%;
    height: 100%;
  }
}

@keyframes navigation-close {
  0% {
    width: 100%;
    height: 100%;
  }

  45% {
    width: 100%;
    height: calc(var(--stripe-purple-width-light) * 2);
  }

  100% {
    width: 0;
    height: calc(var(--stripe-purple-width-light) * 2);
  }
}

:host {
  --stripe-scale: 1.5;
  --top-bar-height: calc(96px * var(--stripe-scale));

  display: flex;
  flex-direction: column;
  height: 100%;
}

.top-bar {
  --stripe-purple-color: 249, 60%;
  --stripe-purple-color-dark: 23%;
  --stripe-purple-color-light: 33%;
  --stripe-purple-width-dark: calc(var(--stripe-scale) * 10px);
  --stripe-purple-width-light: calc(var(--stripe-scale) * 5px);

  --stripe-yellow-color: 54, 100%;
  --stripe-yellow-color-dark: 48%;
  --stripe-yellow-color-light: 58%;
  --stripe-yellow-width-dark: calc(var(--stripe-scale) * 7px);
  --stripe-yellow-width-light: calc(var(--stripe-scale) * 4px);

  --stripe-green-color: 76, 66%;
  --stripe-green-color-dark: 51%;
  --stripe-green-color-light: 61%;
  --stripe-green-width-dark: calc(var(--stripe-scale) * 11px);
  --stripe-green-width-light: calc(var(--stripe-scale) * 6px);

  --stripe-blue-color: 186, 52%;
  --stripe-blue-color-dark: 64%;
  --stripe-blue-color-light: 74%;
  --stripe-blue-width-dark: calc(var(--stripe-scale) * 8px);
  --stripe-blue-width-light: calc(var(--stripe-scale) * 3px);

  --stripe-green-dark-offset: 0px;
  --stripe-green-light-offset: calc(var(--stripe-green-width-dark) + var(--stripe-green-width-light));
  --stripe-blue-dark-offset: calc(var(--stripe-green-light-offset) + var(--stripe-green-width-light) + var(--stripe-blue-width-dark));
  --stripe-blue-light-offset: calc(var(--stripe-blue-dark-offset) + var(--stripe-blue-width-dark) + var(--stripe-blue-width-light));
  --stripe-yellow-dark-offset: calc(var(--stripe-blue-light-offset) + var(--stripe-blue-width-light) + var(--stripe-yellow-width-dark));
  --stripe-yellow-light-offset: calc(var(--stripe-yellow-dark-offset) + var(--stripe-yellow-width-dark) + var(--stripe-yellow-width-light));
  --stripe-purple-dark-offset: calc(var(--stripe-yellow-light-offset) + var(--stripe-yellow-width-light) + var(--stripe-purple-width-dark));
  --stripe-purple-light-offset: calc(var(--stripe-purple-dark-offset) + var(--stripe-purple-width-dark) + var(--stripe-purple-width-light));

  position: fixed;
  z-index: 1;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 calc(var(--ui-sys-unit) * 48) 0 calc(var(--ui-sys-unit) * 80);
  height: var(--top-bar-height);
  max-width: 120rem;

  .top-bar__icons-end {
    margin-left: auto;

    ui-icon-button:not(:last-child) {
      margin-right: calc(var(--ui-sys-unit) * 8);
    }
  }

  &:before {
    content: '';
    position: fixed;
    z-index: 0;
    top: 0;
    left: 0;
    width: 50px;
    box-shadow:
      0 0 0 var(--stripe-green-width-dark) hsl(var(--stripe-green-color), var(--stripe-green-color-dark)),
      0 var(--stripe-green-light-offset) 0 var(--stripe-green-width-light) hsl(var(--stripe-green-color), var(--stripe-green-color-light)),
      0 var(--stripe-blue-dark-offset) 0 var(--stripe-blue-width-dark) hsl(var(--stripe-blue-color), var(--stripe-blue-color-dark)),
      0 var(--stripe-blue-light-offset) 0 var(--stripe-blue-width-light) hsl(var(--stripe-blue-color), var(--stripe-blue-color-light)),
      0 var(--stripe-yellow-dark-offset) 0 var(--stripe-yellow-width-dark) hsl(var(--stripe-yellow-color), var(--stripe-yellow-color-dark)),
      0 var(--stripe-yellow-light-offset) 0 var(--stripe-yellow-width-light) hsl(var(--stripe-yellow-color), var(--stripe-yellow-color-light)),
      0 var(--stripe-purple-dark-offset) 0 var(--stripe-purple-width-dark) hsl(var(--stripe-purple-color), var(--stripe-purple-color-dark)),
      0 var(--stripe-purple-light-offset) 0 var(--stripe-purple-width-light) hsl(var(--stripe-purple-color), var(--stripe-purple-color-light));
    transform: rotate(0);
    transform-origin: left;
  }

  &.navigation--is-opening {
    &:before {
      width: 100%;
      transition: width 0.8s;
    }
  }

  &.navigation--is-open {
    &:before {
      width: 100%;
    }
  }

  &.navigation--is-closing {
    &:before {
      width: 50px;
      transition: width 0.8s;
    }
  }

  .top-bar__brand-name {
    font-family: var(--ui-sys-typescale-font-family-alt);
    color: hsl(var(--ui-sys-color-on-surface));
    display: flex;
    flex-direction: column;
    line-height: 1;
    z-index: 0;

    span:first-child {
      font-size: 36px;
    }
    span:last-child {
      font-size: 12px;
    }
  }
}

.navigation {
  overflow: hidden;
  left: 0;
  top: calc(var(--top-bar-height) - var(--stripe-purple-width-light) * 2 );
  position: fixed;
  width: 0;
  height: calc(var(--stripe-purple-width-light) * 2);
  background: hsl(var(--stripe-purple-color), var(--stripe-purple-color-light));
  z-index: 0;

  --ui-button-label-font: var(--ui-sys-typescale-font-family-alt);

  .navigation__container {
    margin-top: calc(var(--stripe-purple-width-light) * 2);
    padding: 0 calc(var(--ui-sys-unit) * 24) calc(var(--ui-sys-unit) * 24) calc(var(--ui-sys-unit) * 55);
    background: hsl(var(--stripe-purple-color), var(--stripe-purple-color-light));
    height: 100%;
    display: flex;
    flex-direction: column;
  }


  &.navigation--is-opening {
    animation: navigation-open 0.6s ease-in forwards;
  }

  &.navigation--is-closing {
    animation: navigation-close 0.6s ease-out forwards;
  }

  &[aria-expanded="true"] {
    height: 100%;
    width: 100%;
  }

  &[aria-expanded="true"] ~ .top-bar__brand-name {
    color: hsl(var(--ui-ref-palette-primary));
  }

  &[aria-expanded="true"] ~ .top-bar__icons-end {
    --ui-icon-button-icon-color: var(--ui-ref-palette-primary);
    --ui-icon-button-pressed-state-layer-color: var(--ui-ref-palette-primary);
    --ui-icon-button-hover-state-layer-color: var(--ui-ref-palette-primary);
  }

  &.navigation--is-opening ~ .top-bar__brand-name {
    color: hsl(var(--ui-ref-palette-primary));
    transition: color 0.5s;
  }

  &.navigation--is-opening ~ .top-bar__icons-end {
    --ui-icon-button-icon-color: var(--ui-ref-palette-primary);
    --ui-icon-button-pressed-state-layer-color: var(--ui-ref-palette-primary);
    --ui-icon-button-hover-state-layer-color: var(--ui-ref-palette-primary);
  }

  &.navigation--is-closing ~ .top-bar__icons-end {
    --ui-icon-button-icon-color: unset;
  }

  &.navigation--is-closing ~ .top-bar__brand-name {
    color: hsl(var(--ui-sys-color-on-surface));
    transition: color 0.3s 0.5s;
  }
}

main {
  padding-top: var(--top-bar-height);
  height: 100%;
  overflow: hidden;
  flex: 1;
}

footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;

  a, a:visited {
    color: hsl(var(--ui-sys-color-primary));
  }
}

@media screen and (max-width: 820px) {
  .top-bar {
    padding-right: calc(var(--ui-sys-unit) * 32);
  }

  .project {
    flex-direction: column;
    row-gap: calc(var(--ui-sys-unit) * 16);
  }
}

@media screen and (max-width: 600px) {
  :host {
    --stripe-scale: 1;
    --ui-heading-h1-size: calc(var(--ui-sys-unit) * 46);
    --ui-heading-h1-line-height: 1;
  }

  .top-bar {
    padding-right: calc(var(--ui-sys-unit) * 16);
    padding-left: calc(var(--ui-sys-unit) * 60);

    .top-bar__brand-name {
      transform: scale(0.8);
    }

    .navigation {

      &[aria-expanded="true"] ~ .top-bar__brand-name {
        color: hsl(var(--ui-ref-palette-primary));
        transform: translateX(-24px) scale(0.8);
      }

      &.navigation--is-opening ~ .top-bar__brand-name {
        transform: translateX(-24px) scale(0.8);
        transition: color 0.5s, transform 0.5s;
      }

      &.navigation--is-closing ~ .top-bar__brand-name {
        color: hsl(var(--ui-sys-color-on-surface));
        transform: translateX(0) scale(0.8);
        transition: color 0.1s 0.3s, transform 0.3s;
      }

      .navigation__container {
        padding-left: calc(var(--ui-sys-unit) * 24);
      }
    }
  }
}
`
